module.exports = __webpack_public_path__ + "static/img/dislikeIcon.de007c95.svg";